import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('junto_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth
export const register = async (userData) => {
  const response = await apiClient.post('/auth/register', userData);
  return response.data;
};

export const login = async (credentials) => {
  const response = await apiClient.post('/auth/login', credentials);
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};

export const getUserOrders = async () => {
  const response = await apiClient.get('/auth/orders');
  return response.data;
};

// Products
export const getProducts = async (category = null, featured = null) => {
  const params = {};
  if (category) params.category = category;
  if (featured !== null) params.featured = featured;
  
  const response = await apiClient.get('/products', { params });
  return response.data;
};

export const getProduct = async (id) => {
  const response = await apiClient.get(`/products/${id}`);
  return response.data;
};

// Cart
export const getCart = async (sessionId) => {
  const response = await apiClient.get(`/cart/${sessionId}`);
  return response.data;
};

export const addToCart = async (sessionId, productId, quantity = 1, weight = null, grind = "Çekirdek (Öğütme İstemiyorum)", color = null) => {
  const payload = {
    session_id: sessionId,
    product_id: productId,
    quantity: quantity,
    grind: grind,
  };
  
  if (weight) payload.weight = weight;
  if (color) payload.color = color;
  
  const response = await apiClient.post('/cart/add', payload);
  return response.data;
};

export const updateCartItem = async (sessionId, productId, quantity, weight = null, color = null) => {
  const payload = {
    session_id: sessionId,
    product_id: productId,
    quantity: quantity,
  };
  
  if (weight) payload.weight = weight;
  if (color) payload.color = color;
  
  const response = await apiClient.post('/cart/update', payload);
  return response.data;
};

export const clearCart = async (sessionId) => {
  const response = await apiClient.delete(`/cart/${sessionId}`);
  return response.data;
};

// Orders
export const createOrder = async (sessionId, customerData) => {
  const response = await apiClient.post('/orders', {
    session_id: sessionId,
    ...customerData,
  });
  return response.data;
};

export const getOrder = async (orderId) => {
  const response = await apiClient.get(`/orders/${orderId}`);
  return response.data;
};

// Reviews
export const getReviews = async (productId) => {
  const response = await apiClient.get(`/reviews/${productId}`);
  return response.data;
};

export const createReview = async (productId, customerName, rating, comment) => {
  const response = await apiClient.post('/reviews', {
    product_id: productId,
    customer_name: customerName,
    rating: rating,
    comment: comment,
  });
  return response.data;
};
